import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function GooglePay({
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M17.617 6H6.383C2.872 6 0 8.872 0 12.383c0 3.51 2.872 6.383 6.383 6.383h11.234c3.51 0 6.383-2.872 6.383-6.383C24 8.872 21.128 6 17.617 6z"
        fill="white"
      />
      <Path
        d="M17.617 6.517c.788 0 1.554.156 2.276.463a5.918 5.918 0 011.867 1.26 5.918 5.918 0 011.26 1.867c.307.722.463 1.488.463 2.276s-.156 1.554-.463 2.276a5.918 5.918 0 01-1.26 1.867 5.918 5.918 0 01-1.867 1.26 5.79 5.79 0 01-2.276.464H6.383a5.79 5.79 0 01-2.276-.463 5.918 5.918 0 01-1.867-1.261A5.918 5.918 0 01.98 14.659a5.79 5.79 0 01-.463-2.276c0-.788.156-1.554.463-2.276A5.917 5.917 0 014.107 6.98 5.79 5.79 0 016.383 6.517h11.234zM17.617 6H6.383C2.872 6 0 8.872 0 12.383c0 3.51 2.872 6.383 6.383 6.383h11.234c3.51 0 6.383-2.872 6.383-6.383C24 8.872 21.128 6 17.617 6z"
        fill="#3C4043"
      />
      <Path
        d="M11.445 12.836v1.931h-.613V9.999h1.624c.412 0 .763.137 1.05.412.294.274.441.61.441 1.005 0 .405-.147.74-.441 1.012-.284.27-.635.405-1.05.405h-1.011v.003zm0-2.25v1.663h1.024c.243 0 .447-.083.607-.246a.803.803 0 00.245-.584.795.795 0 00-.245-.578.795.795 0 00-.607-.252h-1.024v-.003z"
        fill="#3C4043"
      />
      <Path
        d="M15.549 11.397c.453 0 .81.121 1.072.364.262.243.392.575.392.996v2.01h-.584v-.453h-.025c-.253.374-.591.559-1.012.559-.36 0-.66-.106-.903-.32a1.019 1.019 0 01-.364-.798c0-.338.128-.606.383-.804.256-.201.597-.3 1.021-.3.364 0 .664.067.897.201v-.14a.695.695 0 00-.252-.543.865.865 0 00-.594-.223.931.931 0 00-.81.434l-.54-.339c.297-.43.738-.644 1.319-.644zm-.791 2.368c0 .16.067.294.204.399a.75.75 0 00.475.16c.259 0 .489-.096.69-.288a.901.901 0 00.303-.673c-.191-.15-.456-.227-.798-.227-.249 0-.456.06-.622.179-.17.124-.252.274-.252.45z"
        fill="#3C4043"
      />
      <Path
        d="M20.346 11.502L18.303 16.2h-.632l.76-1.644-1.347-3.054h.667l.97 2.343h.013l.945-2.343h.667z"
        fill="#3C4043"
      />
      <Path
        d="M9.007 12.447a2.57 2.57 0 00-.05-.575H6.387v1.053h1.48a1.27 1.27 0 01-.549.849v.683h.88c.515-.476.81-1.18.81-2.01z"
        fill="#4285F4"
      />
      <Path
        d="M7.318 13.774a1.65 1.65 0 01-.93.262c-.713 0-1.318-.48-1.535-1.129h-.908v.705a2.734 2.734 0 002.443 1.506c.739 0 1.36-.243 1.811-.661l-.88-.683z"
        fill="#34A853"
      />
      <Path
        d="M4.768 12.385c0-.182.03-.358.085-.524v-.704h-.908a2.72 2.72 0 00-.29 1.228c0 .441.104.858.29 1.227l.908-.704a1.65 1.65 0 01-.085-.523z"
        fill="#FABB05"
      />
      <Path
        d="M6.388 10.733c.404 0 .765.139 1.05.41l.78-.78a2.627 2.627 0 00-1.83-.712 2.735 2.735 0 00-2.443 1.506l.908.704c.217-.647.822-1.128 1.535-1.128z"
        fill="#E94235"
      />
    </Svg>
  );
}
